import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { VBox } from '../../../components/Box';
import { INVOICE_TYPES } from "../constants";

const Container = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;

const STATE = {
  items: [
    {
      id: INVOICE_TYPES.INVOICE,
      label: INVOICE_TYPES.INVOICE,
    },
    {
      id: INVOICE_TYPES.CREDIT,
      label: INVOICE_TYPES.CREDIT,
    },
  ],
};

/* eslint-disable react/prefer-stateless-function */
class TypeSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get items() {
    return this.state.items;
  }

  render() {
    return (
      <Container>
        <VBox>
          {this.renderItems()}
        </VBox>
      </Container>
    );
  }

  renderItems() {
    if (!this.items) return '';
    return (
      <div className="results">
        <List>
          {this.items.map(i => (
            <Row key={i.id} onClick={() => this.props.onSelect?.(i)}>
              <Cell>{i.label}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

TypeSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const TypeSelection = compose(
  withConnect,
  withRouter,
)(TypeSelectionComp);
